export default function VerifyEmail() {
  return (
    <section className="auth-page">
      <div className="auth-container">
        <h2>Sprawdź skrzynkę e-mail</h2>
        <p>Jeśli to Twoje pierwsze logowanie, wysłaliśmy link weryfikacyjny. Otwórz wiadomość i potwierdź e-mail.</p>
      </div>
    </section>
  );
}
